import { useEffect, useState } from "react";
import { collection, getDocs } from "firebase/firestore";
import { db, auth } from "../firebase";
import { generaByFamily } from "../utils/taxonomy";

export default function AdminEmptyGeneraPage() {
  const [emptyGenera, setEmptyGenera] = useState([]);

  useEffect(() => {
    async function runCheck() {
      // 1️⃣ Build full genus list from taxonomy.js
      const allGenera = [
        ...new Set(
          Object.values(generaByFamily)
            .flat()
            .map((g) => g.trim()),
        ),
      ];

      // 2️⃣ Fetch ONLY current user's species
      const uid = auth.currentUser?.uid;
      if (!uid) return;

      const speciesSnap = await getDocs(
        collection(db, "users", uid, "species"),
      );

      const generaWithSpecies = new Set();

      speciesSnap.forEach((doc) => {
        const data = doc.data();
        if (data.genus) {
          generaWithSpecies.add(data.genus.trim());
        }
      });

      // 4️⃣ Find genera that are not used
      const unused = allGenera.filter((genus) => !generaWithSpecies.has(genus));

      setEmptyGenera(unused);
    }

    runCheck();
  }, []);

  return (
    <div className="p-6 max-w-4xl mx-auto text-sm">
      <h2 className="text-lg font-semibold mb-4">
        Genera With No Species Assigned
      </h2>

      <div className="space-y-1">
        {emptyGenera.map((g) => (
          <div key={g} className="border-b py-1">
            {g}
          </div>
        ))}
      </div>

      {emptyGenera.length === 0 && (
        <div className="text-slate-500">
          All genera have at least one species.
        </div>
      )}
    </div>
  );
}
